import { CSSProperties, ReactNode } from 'react';
import { Badge } from 'src/components/ui';
import { useDarkMode, toContrastColor, toAlertBg, toAlertBorder } from '../context/DarkModeContext';

const HEX_RE = /^#([a-f\d]{3}|[a-f\d]{6})$/i;

type CustomBadgeProps = {
  color: string;
  children?: ReactNode;
  style?: CSSProperties;
  className?: string;
  pill?: boolean;
};

export default function CustomBadge({ color, children, style, className, pill }: CustomBadgeProps) {
  const { isDarkMode } = useDarkMode();

  if (HEX_RE.test(color)) {
    const resolvedColor = isDarkMode ? toContrastColor(color) : color;
    const bg = isDarkMode ? toAlertBg(color) : `${color}18`;
    const border = isDarkMode ? toAlertBorder(color) : color;

    return (
      <span
        className={`badge${pill ? ' rounded-full' : ''}${className ? ` ${className}` : ''}`}
        style={{
          backgroundColor: bg,
          color: resolvedColor,
          border: `1px solid ${border}`,
          fontWeight: 600,
          alignItems: 'center',
          ...style,
        }}
      >
        {children}
      </span>
    );
  }

  return (
    <Badge color={color} pill={pill} className={className} style={style}>
      {children}
    </Badge>
  );
}
